<div class="banner" [style.background]="background()">
  @if (image()) {
    <img [src]="image()" class="banner-image" alt="" />
  }

  <div class="banner-content">
    @if (title()) {
      <div class="font-l-semibold banner-title">{{ title() }}</div>
    } @else {
      <ng-content select="[bannerTitle]" />
    }
    @if (description()) {
      <p class="font-s-regular banner-description">{{ description() }}</p>
    } @else {
      <ng-content select="[bannerDescription]" />
    }
    <ng-content select="[bannerAction]" />
  </div>
</div>
